import { t } from '@lingui/core/macro';
import type { CarFleetViewRecord, EndOwnershipReason } from '@navio/nsdk';
import { EndOwnershipReason as EndOwnershipReasonValues } from '@navio/nsdk';

export type EndOwnershipAction = {
  car: CarFleetViewRecord;
  reason: EndOwnershipReason;
};

export const getEndOwnershipTitle = (action?: EndOwnershipAction): string => {
  switch (action?.reason) {
    case EndOwnershipReasonValues.SOLD:
      return t`Mark car as sold?`;
    case EndOwnershipReasonValues.WRECKED_SCRAPPED:
      return t`Mark car as decommissioned?`;
    case EndOwnershipReasonValues.NEVER_OWNED:
      return t`Remove car that is not yours?`;
    default:
      return t`End ownership?`;
  }
};

export const getEndOwnershipConfirmText = (action?: EndOwnershipAction): string => {
  switch (action?.reason) {
    case EndOwnershipReasonValues.SOLD:
      return t`Mark as sold`;
    case EndOwnershipReasonValues.WRECKED_SCRAPPED:
      return t`Mark as decommissioned`;
    case EndOwnershipReasonValues.NEVER_OWNED:
      return t`Remove car`;
    default:
      return t`Confirm`;
  }
};
